<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        tile
        color="primary"
        class="elevation-0 mb-2"
      >
        <v-card-title
          class="font-weight-medium grey--text pt-1 pb-2"
        >
          Contratistas
        </v-card-title>
        <v-card-subtitle class="pb-2">
          Listado de accesos
        </v-card-subtitle>
      </v-card>
      <v-card
        tile
        color="grey lighten-3"
        class="elevation-0"
      >
        <v-container fluid>
          <v-row dense>
            <v-col cols="3" sm="2">
              <v-select
                v-model="form.project"
                :items="projectsList"
                label="Proyecto"
                item-text="name"
                item-value="id"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="3" sm="2">
              <date-component
                v-model="form.date_entry_before"
                label="Fecha ingreso desde"
              ></date-component>
            </v-col>
            <v-col cols="3" sm="2">
              <date-component
                v-model="form.date_entry_after"
                label="Fecha ingreso hasta"
              ></date-component>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="3" sm="6">
              <v-text-field
              v-model="form.search"
              label="Buscar por nombre o empresa"
              hide-details
              dense
              outlined
              append-icon="mdi-magnify"
            >
              <template v-if="form.search" v-slot:append>
                <v-icon
                  @click.prevent="crearFilters"
                  link
                >
                  mdi-close
                </v-icon>
              </template>
            </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-right">
              <vue-excel-xlsx
                :data="accessList.results"
                :columns="columns"
                :filename="'Export Accessos Fecha'"
                :sheetname="'Listado de Accesos'"
                >
                <v-btn
                    x-small
                    outlined
                    color="primary"
                    class="mx-2"
                  >
                    Descargar
                    <v-icon right dark>mdi-cloud-download</v-icon>
                  </v-btn>
              </vue-excel-xlsx>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card v-if="allowDisplayData" class="elevation-0 mt-3" tile>
        <v-data-table
          :headers="headers"
          :items="accessList.results"
          class="elevation-0"
          :loading="loading"
          :options.sync="options"
          :server-items-length="accessList.count"
        >
          <template v-slot:item.profile="{ item }">
            {{ item.profile.profile_name }}
          </template>
          <template v-slot:item.company="{ item }">
            <template v-if="item.profile.empresa">
              <span
                class="text-capitalize"
              >
                {{ item.profile.empresa.toLowerCase() }}
              </span>
            </template>
          </template>
          <template v-slot:item.project="{ item }">
            <span class="text-capitalize">{{ item.project }}</span>
          </template>
          <template v-slot:item.date_entry="{ item }">
            {{ item.date_check_in}}
          </template>
          <template v-slot:item.date_out="{ item }">
            <template v-if="item.date_check_out">
                {{ item.date_check_out }}
            </template>
          </template>
        </v-data-table>
      </v-card>
        <v-alert v-else
          color="red"
          type="error"
        >
          Su usuario no tiene permiso para ver este listado de accesos...
        </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import types from '@/types';
import DateComponent from '@/components/DateComponent';
import moment from 'moment';
import _ from 'lodash';

export default {
  components: {
    DateComponent,
  },

  data() {
    return {
      form: {
        project: '',
        date_entry_after: '',
        date_entry_before: '',
        search: '',
      },
      options: {},
      headers: [
        { text: 'Nombre Colaborador', value: 'profile' },
        { text: 'Empresa', value: 'company' },
        { text: 'Proyecto', value: 'project' },
        { text: 'Fecha/hora llegada', value: 'date_entry', xlsFormat: 'dateFormat' },
        { text: 'Fecha/hora salida', value: 'date_out', xlsFormat: 'dateFormat' },
      ],
      loading: true,
      invitationId: null,
      showCheckin: false,
      showCheckout: false,
      showDetailCheckout: false,
      autoUpdate: true,
      interval: null,
      allowDisplayData: true,
    };
  },

  computed: {
    ...mapState(
      `${types.INVITATION}`, [
        'projectsList',
        'accessList',
        'totalIntivations',
      ],
    ),
    limit() {
      return this.options.itemsPerPage === -1
        ? this.totalIntivations : this.options.itemsPerPage;
    },
    columns() {
      return this.headers.map((item) => ({
        label: item.text,
        field: item.value,
        dataFormat: this[item.xlsFormat] ? this[item.xlsFormat] : this.generalFormat,
      }));
    },
  },

  watch: {
    form: {
      handler() {
        const clearPage = true;
        this.debouncedGetAccesses(this.getOptions(clearPage));
      },
      deep: true,
    },
    options: {
      handler() {
        const clearPage = false;
        this.getAccesses(this.getOptions(clearPage));
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations({
      [types.SHOW_BUSY]: `${types.APP}/${types.SHOW_BUSY}`,
      [types.HIDE_BUSY]: `${types.APP}/${types.HIDE_BUSY}`,
    }),
    ...mapActions({
      [types.SETUP_FACE_CONTROL_ACCESS]: `${types.INVITATION}/${types.SETUP_FACE_CONTROL_ACCESS}`,
      [types.LIST_ACCESS]: `${types.INVITATION}/${types.LIST_ACCESS}`,
    }),
    getOptions(clearPage) {
      const params = {
        project: this.form.project,
        date_entry_after: this.form.date_entry_after,
        date_entry_before: this.form.date_entry_before,
        search: this.form.search,
        page: this.options.page,
        limit: this.limit,
      };
      if (clearPage) {
        delete params.page;
      }
      return params;
    },
    getTypeColor(type) {
      const colors = {
        'Family/Friends': 'light-blue darken-3',
        'Friends and Family': 'light-blue darken-3',
        Supplier: 'warning',
      };
      return colors[type];
    },
    getColor(status) {
      const colors = {
        Pending: 'success',
        'In House': 'warning lighten-1',
        'Check Out': 'error lighten-1',
        Cancelled: 'grey',
        'Overdue In House': 'error darken-1',
      };
      return colors[status];
    },
    generalFormat(value) {
      return value;
    },
    invitedName(value) {
      return value.invitated.name;
    },
    dateFormat(value) {
      return moment(value).format('DD-MMM-YYYY');
    },
    hourFormat(value) {
      return moment(value).format('HH:mm');
    },
    floatFormat(value) {
      return parseFloat(value) ? parseFloat(value) : value;
    },
    getAction(status) {
      const actions = {
        Pending: 'Check-in',
        'In House': 'Check-out',
        'Check Out': 'Ver',
        Cancelled: 'Ver',
        'Overdue In House': 'Check-out',
      };
      return actions[status];
    },
    getAccesses(params) {
      this.loading = true;
      this[types.LIST_ACCESS](params)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status === 403) {
            this.allowDisplayData = false;
          }
        })
        .finally(() => {
          this[types.HIDE_BUSY]();
          this.loading = false;
        });
    },
    dispatchAction(status, invitationId) {
      switch (status) {
        case 'Pending':
          this.invitationId = invitationId;
          this.showCheckin = true;
          break;
        case 'In House':
        case 'Overdue In House':
          this.invitationId = invitationId;
          this.showCheckout = true;
          break;
        case 'Check Out':
          this.invitationId = invitationId;
          this.showDetailCheckout = true;
          break;
        default:
          this.$router.push({ name: 'Todo' });
          break;
      }
    },
    crearFilters() {
      this.form.search = '';
      this.form.date_entry = '';
    },
  },

  mounted() {
    this[types.SHOW_BUSY]('Cargando...');
    this[types.SETUP_FACE_CONTROL_ACCESS]();
    this.debouncedGetAccesses = _.debounce(this.getAccesses, 1000);
  },

  created() {
    const today = new Date();
    const yesterday = new Date(today.setDate(today.getDate() - 1));
    // eslint-disable-next-line no-underscore-dangle
    this.form.date_entry_before = yesterday.toISOString().substr(0, 10);
    this.form.date_entry_after = new Date().toISOString().substr(0, 10);
    if (this.projectsList.length > 0) {
      this.form.project = this.projectsList[0].id;
    }
  },

  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style>
.v-data-table__wrapper tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
.v-chip-status {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/ContratistaAccesoListado.vue